/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DataCategory from './data-category';
import DataCategoryDetail from './data-category-detail';
import DataCategoryUpdate from './data-category-update';
import DataCategoryDeleteDialog from './data-category-delete-dialog';

const DataCategoryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DataCategory />} />
    <Route path="new" element={<DataCategoryUpdate />} />
    <Route path=":id">
      <Route index element={<DataCategoryDetail />} />
      <Route path="edit" element={<DataCategoryUpdate />} />
      <Route path="delete" element={<DataCategoryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DataCategoryRoutes;
